
import { NavLink } from "./NavLink";
import { useTranslation } from "react-i18next";

interface MobileMenuProps {
  isOpen: boolean;
  isActive: (path: string) => boolean;
  onLinkClick: () => void;
}

export const MobileMenu = ({ isOpen, isActive, onLinkClick }: MobileMenuProps) => {
  const { t } = useTranslation(["menu"]);
  
  if (!isOpen) return null;

  return (
    <div className="md:hidden bg-white shadow-lg rounded-b-lg">
      <div className="flex flex-col space-y-4 p-4">
        <NavLink to="/drh" isActive={isActive("/drh")} onClick={onLinkClick} mobile>
          {t('hr')}
        </NavLink>
        <NavLink to="/recruteurs" isActive={isActive("/recruteurs")} onClick={onLinkClick} mobile>
          {t('recruiters')}
        </NavLink>
        <NavLink to="/particuliers" isActive={isActive("/particuliers")} onClick={onLinkClick} mobile>
          {t('individuals')}
        </NavLink>
        <NavLink to="/formations" isActive={isActive("/formations")} onClick={onLinkClick} mobile>
          {t('training')}
        </NavLink>
        <NavLink to="/rncp-presentation" isActive={isActive("/rncp-presentation")} onClick={onLinkClick} mobile>
          {t('rncp')}
        </NavLink>
        <NavLink to="/meta-referentiel" isActive={isActive("/meta-referentiel")} onClick={onLinkClick} mobile>
          {t('metaReferential')}
        </NavLink>
        <NavLink to="/search-engine" isActive={isActive("/search-engine")} onClick={onLinkClick} mobile>
          {t('searchEngine')}
        </NavLink>
      </div>
    </div>
  );
};
